import { Box, Title, Card, Space } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { FC } from "react";
import { GetManyOrdersOfUserDocument, OrderStatus } from "/@/generated/graphql";
import { useQuery } from "@apollo/client";
import { OrderSummaryRow } from "/@/components/order/OrderSummaryRow";

export const NotificationsListPage: FC = () => {
  const { data: getDraftOrdersData } = useQuery(GetManyOrdersOfUserDocument, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        status: {
          equals: OrderStatus.Draft,
        },
      },
    },
  });

  const { classes } = useStyles();

  if (!getDraftOrdersData) {
    return null;
  } else if (getDraftOrdersData.getManyOrdersOfUser.length === 0) {
    return (
      <Box
        style={theme => ({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          backgroundColor: theme.colors.greyScale[9],
        })}
      >
        <Title
          order={3}
          style={theme => ({
            color: theme.colors.greyScale[2],
          })}
        >
          {"Aucune notification"}
        </Title>
      </Box>
    );
  }
  return (
    <>
      <Box className={classes.container}>
        <Title
          order={2}
          style={{
            color: "#28335B",
            fontWeight: 700,
            fontSize: "1.5rem",
          }}
        >
          Vos notifications
        </Title>
        <Space h="md" />
        <Card className={classes.ordersCard}>
          {getDraftOrdersData.getManyOrdersOfUser
            .slice(0)
            .reverse()
            .map((order, index, array) => {
              return (
                <OrderSummaryRow
                  key={order.id}
                  order={order}
                  variant="compact"
                  isLast={index === array.length - 1}
                />
              );
            })}
        </Card>
      </Box>
    </>
  );
};

const useStyles = createStyles(theme => ({
  container: {
    padding: theme.spacing.lg,
  },
  ordersCard: {
    border: `1px solid ${theme.colors.greyScale[8]}`,
    boxShadow: "none",
    backgroundColor: theme.white,
    borderRadius: theme.radius.lg,
    padding: "0 1rem 0 1rem",
  },
}));
